import { render } from "./main-banner-com.vue?vue&type=template&id=849c4366&scoped=true"
import script from "./main-banner-com.vue?vue&type=script&lang=js"
export * from "./main-banner-com.vue?vue&type=script&lang=js"

import "./main-banner-com.vue?vue&type=style&index=0&id=849c4366&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849c4366"]])

export default __exports__